import script from "./VProjectNavigator.vue?vue&type=script&setup=true&lang=ts"
export * from "./VProjectNavigator.vue?vue&type=script&setup=true&lang=ts"

import "./VProjectNavigator.vue?vue&type=style&index=0&id=e18c866c&lang=scss"

const __exports__ = script;

export default __exports__